<script lang="ts">
  import { Save } from "lucide-svelte";
  export let isSaving: boolean = false;
  export let isError: boolean = false;
</script>

<div class="relative inline-flex items-center">
  <Save class="h-4 w-4" />

  {#if isSaving}
    <div class="absolute inset-0 flex justify-center items-center">
      <div
        class=" h-px -my-1 w-full bg-primary absolute bottom-0 animate-ping"
      ></div>
    </div>
 {:else if isError }
    <div class="absolute inset-0 flex justify-center items-center">
      <div
        class=" h-1 -my-1 w-full bg-red-500 absolute bottom-0"
      ></div>
    </div>
  {/if}
</div>
